export const PRIMARY = '#077b7a';